module.exports = __webpack_public_path__ + "media/images/smart_phone/rails-07db7c5863141d930f2e7a546282ad26.png";